import tinymce from "tinymce";
import 'tinymce/themes/silver/theme'
import 'tinymce/models/dom/model'
import 'tinymce/icons/default/icons.min.js'
import 'tinymce/skins/ui/oxide/skin.css'
// import * as Diff from 'diff';
// import xss from 'xss';
import { npuEventStatistics, getCourseTypeInfo } from '../utils/npuTracker'
const diffMatchPatch = require('diff-match-patch');
const dmp = new diffMatchPatch();
export const downloadNote = (data, { courseName, resourceName }) => {
    var url = "/edudatacenter/v1/learning-note-service/download"; //接口
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.responseType = "blob";  // 返回类型blob
    xhr.setRequestHeader("Content-type", "application/json;charset=utf-8"); //这个看后端接口情况决定要不要写
    if (localStorage.getItem('x-cas-token-app') || '') {
        let headers = {
            'x-cas-token': localStorage.getItem('x-cas-token-app') || ''
        }
        Object.keys(headers).map(key => {
            xhr.setRequestHeader(key, headers[key]);
        })
    }
    // 定义请求完成的处理函数，请求前也可以增加加载框/禁用下载按钮逻辑
    xhr.onload = function () {
        // 请求完成
        if (this.status === 200) {
            // 返回200
            var blob = this.response;
            // 获取服务端返回的文件名
            var filename = '';
            var disposition = xhr.getResponseHeader('Content-Disposition');
            if (disposition && disposition.indexOf('attachment') !== -1) {
                var filenameRegex = /filename\*=UTF-8''([\w%\-\.]+)(?:; ?|$)/i;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = decodeURIComponent(matches[1])
                    let split = filename.split('.')

                    filename = (courseName || '') + (resourceName ? ('-' + resourceName) : '') + '笔记.' + split[split.length - 1]
                }
            }
            var reader = new FileReader();
            reader.readAsDataURL(blob);  // 转换为base64，可以直接放入a表情href
            reader.onload = function (e) {
                // 转换完成，创建一个a标签用于下载
                var a = document.createElement('a');
                a.download = filename;
                a.href = e.target.result;
                jQuery("body").append(a);  // 修复firefox中无法触发click
                a.click();
                jQuery(a).remove();
            }
        }
    };
    // 发送ajax请求
    xhr.send(JSON.stringify(data))
}
// 时长转换，百纳秒转时分秒
export const durationTrans = (a) => {
    a = parseInt((a || 0) / 10000000)
    var b = ""
    var h = parseInt(a / 3600),
        m = parseInt(a % 3600 / 60),
        s = parseInt(a % 3600 % 60);
    h = h < 10 ? '0' + h : h
    m = m < 10 ? '0' + m : m
    s = s < 10 ? '0' + s : s
    b += h + ":" + m + ":" + s
    return b;
}
export const getNoteHtml = (option) => {
    if (option.type === 'screenshoot') {
        //截图笔记
        let { img, time } = option || {}
        let timeFormat = durationTrans(time)
        return `<div class="custom_screenshoot" data-time="${time}" contenteditable="false">
        <img class="keyframe" src="${img}" />
        <img class="icon" src="/learn/static/imgs/play_icon.png" />
        <span class="time">${timeFormat}</span>
    </div><br/>`
    } else if (option.type === 'time') {
        //时间点笔记
        let { time, timeFormat, text, tag = [] } = option || {}
        return `<div class="custom_time" data-time="${time}" contenteditable="false">
        <span class="time">
            <img class="icon" src="/learn/static/imgs/flag_icon.png" />
            <span class="time">${timeFormat}</span>
        </span>
        <span class="content">${text}</span>
        ${tag.includes('1') ? '<span class="tag important"><img class="icon" src="/learn/static/imgs/note_important_icon.png"/>重点</span>' : ''}
        ${tag.includes('2') ? '<span class="tag difficult"><img class="icon" src="/learn/static/imgs/note_difficult_icon.png"/>难点</span>' : ''}
    </div><br/>`
    } else if (option.type === 'text') {
        //语音文本笔记
        let { pointIn, pointOut, text } = option || {}
        let timeFormat = durationTrans(pointIn)
        return `<div class="custom_text" data-time="${pointIn}" contenteditable="false">
        <span class="time"><img class="icon" src="/learn/static/imgs/play_icon.png" />${timeFormat}</span>
        <span class="text_content">${text}</span>
    </div><br/>`
    } else {
        //插入内容
        let { text } = option || {}
        return `<p>${text}</p>`
    }
}
//获取插入内容
export const getNoteContent = (el) => {
    if (el.keyframe) {
        //截图笔记
        let note = ''
        note = getNoteHtml({ type: 'screenshoot', img: el.keyframe, time: el.pointIn })
        if (el.remark) {
            note += getNoteHtml({ text: el.remark })
        }
        return note
    } else if (el.note) {
        //语音文本笔记
        let note = ''
        note = getNoteHtml({ type: 'text', pointIn: el.pointIn, pointOut: el.pointOut, text: el.note })
        if (el.remark) {
            note += getNoteHtml({ text: el.remark })
        }
        return note
    } else if (el.remark) {
        return getNoteHtml({ text: el.remark })
    } else {
        return el.note
    }
}
Vue.component("course_note_panel_new", {
    props: {
        player: {
            required: true,
        },
        note_info: {
            type: Object,
            required: true,
        },
        if_this_tab: {
            type: Boolean,
            default: false,
        },
        length: {
            type: Number,
        },
        has_login: {
            type: Boolean,
            default: true
        },
        theme: {
            type: String,
            default: ''
        },
        file_type: {
            type: String,
            default: 'biz_sobey_video'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        this.editor = null
        return {
            noteInfo: {},
            noteid: "",
            addLoading: false,
            screenShotLoading: false,
            requestStatus: false,
            canAddNote: false,// 能否添加笔记
            noteContent: '',
            timeNoteVisible: false,
            timeNoteParams: {},
            keyDifficultPoints: [],
            previewNote: '',
            oldData: [],//老数据
            screenshootLoading: false,
            lastContent: '',
            ifVideo: false,
            ifInitUnload: false,
        };
    },
    watch: {
        note_info: {
            handler(newVal, oldVal) {
                this.initData()
            },
            deep: true,
            immediate: true,
        },
        has_login: {
            handler(newVal, oldVal) {
                this.initData()
            },
            immediate: true,
        },
        player: {
            handler(newVal, oldVal) {
                this.canAddNote = (newVal && newVal.videoId) || (newVal && this.isLive) || (newVal && newVal.urls)
                this.ifVideo = newVal && ((newVal.config && newVal.config.url) || newVal.urls)
            },
            immediate: true,
            // deep: true,//m3u8会报错堆栈溢出
        }
    },
    computed: {
        //是否是直播笔记
        isLive() {
            return this.note_info.noteType == 'live'
        },
    },
    mounted() {
        const that = this
    },
    methods: {
        initUnload() {
            const that = this
            window.addEventListener('beforeunload', function (e) {
                if (process.env.NODE_ENV == 'production') {
                    //正式环境才弹窗提示保存
                    event.returnValue = '你确定要离开吗？';
                }
                // 关闭窗口是调用一次保存
                that.saveNote()
            });
            that.ifInitUnload = true
        },
        //获取笔记
        initData() {
            const that = this
            that.noteInfo.note = ''
            that.noteInfo.id = ''
            // console.log('获取笔记列表', this.note_info)
            //微课不用判断resourceId，mooc、spoc需要判断resourceId
            return new Promise((resolve, reject) => {
                // 增加ready字段判断是否可获取列表
                if (!this.note_info.ready) return resolve()
                let param = { ...this.note_info }
                delete param.defaultImage
                API.reqCourseNoteList({
                    pageIndex: 1,
                    pageSize: 999,
                    orderBy: this.isLive ? 'modifyTime' : "pointIn",
                    isDesc: this.isLive,
                    ...param,
                }).then((res) => {
                    if (res.statusCode === config.eduSuccessCode && res.data.items && res.data.items.length) {
                        let richTextNote = res.data.items.find(el => el.type == 'richText') || {}
                        this.noteInfo = richTextNote;
                        this.keyDifficultPoints = richTextNote.keyDifficultPoints || []
                        //过滤出老数据
                        this.oldData = res.data.items.filter(el => el.type != 'richText')
                    }
                }).finally(() => {
                    //兼容老数据
                    // console.log('oldData', this.oldData)
                    if (this.oldData && this.oldData.length) {
                        let oldNote = this.oldData.map(el => {
                            return getNoteContent(el)
                        })
                        this.noteInfo.note = oldNote.join('') + '<br/>' + this.noteInfo.note;
                    }
                    this.initEditor(this.noteInfo.note, this.oldData.map(el => el.id))
                    resolve()
                })
            });
        },
        initEditor(content = '', oldIds) {
            const that = this;
            this.$nextTick(() => {
                let option = {
                    target: that.$refs.textarea,
                    branding: false, //隐藏右下角技术支持
                    promotion: false, //隐藏顶部upgrade
                    menubar: false, //隐藏顶部菜单
                    toolbar: 'fontsize forecolor backcolor italic underline strikethrough align',
                    statusbar: false, //隐藏底部状态栏
                    font_formats: 'alignLeft alignRight',
                    height: '100%',
                    relative_urls: false,
                    skin: false,
                    content_css: '/learn/static/js/bundle/note_editor.css',
                    readonly: false,
                    setup: function (editor) {
                        that.editor = editor
                        editor.on('Click', function (e) {
                            // 在这里处理点击事件
                            // console.log('点击了', e);
                            let el = e.srcElement
                            let className = el.getAttribute('class')
                            if (!className) return
                            if (className.includes('custom_screenshoot') || className.includes('custom_time') || className.includes('custom_text')) {
                                let time = el.getAttribute('data-time')
                                that.playerSeek({ pointIn: time })
                            }
                        });
                        editor.on('blur', function () {
                            that.saveNote()
                        })
                        editor.on('NodeChange', function () {
                            setTimeout(() => {
                                that.findDeleteDifficultPoints()
                            }, 100);
                        })
                        editor.on('keyup', function () {
                            if(!that.ifInitUnload){
                                that.initUnload()
                            }
                        })
                    },
                    //初始化结束后执行
                    init_instance_callback(editor) {
                        console.log('编辑器初始化完成', editor)
                        editor.setContent(content)
                        that.appendToolbar(editor)
                        if (oldIds && oldIds.length) {
                            //有兼容老数据的立即调用更新
                            that.saveNote(oldIds)
                        }
                    },
                }
                if (this.theme == 'dark') {
                    option.skin_url = '/learn/static/css/common/tinymceskin/dark'
                    option.skin = 'dark'
                }
                try {
                    if (that.editor) {
                        that.editor.setContent(content);
                    } else {
                        tinymce.init(option);
                    }
                } catch(err) {
                    // console.error(err)
                }
            })
        },
        //找出删除的重难点列表
        findDeleteDifficultPoints() {
            const that = this
            let currrentContent = that.editor.getContent()
            // console.log('lastContent', that.lastContent)
            // console.log(currrentContent)
            // let diffContent = Diff.diffChars(that.lastContent, currrentContent)
            let diffContent = dmp.diff_main(that.lastContent, currrentContent)
            // console.log('diffContent',  diffContent)
            let removed = diffContent.filter(el => el[0] == -1).map(el => el[1])
            console.log('removed', removed)
            removed.map(el => {
                let div = document.createElement('div')
                if(el[el.length - 1] == '<'){
                    //去除最后一个元素，对比出来会将标签开头的<放到最后去，暂时原因还未知
                    el = '<' + el.substring(0, el.length - 1)
                }
                div.innerHTML = el
                let timeDom = div.querySelector('.custom_time')
                if (!timeDom) return
                let difficultDom = timeDom.querySelector('.tag.difficult')
                let importantDom = timeDom.querySelector('.tag.important')
                if (difficultDom || importantDom) {
                    //删除了重点或难点标记
                    let time = timeDom.getAttribute('data-time')
                    let content = timeDom.querySelector('.content').innerHTML
                    console.log('重难点', time, content, that.keyDifficultPoints)
                    let newArr = []
                    that.keyDifficultPoints = that.keyDifficultPoints || []
                    for (let i = 0; i < that.keyDifficultPoints.length; i++) {
                        let el = that.keyDifficultPoints[i]
                        if (el.timePointName == content && el.pointIn == time) {
                            if (difficultDom) {
                                el.isDifficultPoint = false
                            }
                            if (importantDom) {
                                el.isKeyPoint = false
                            }
                            if (el.isDifficultPoint || el.isKeyPoint) {
                                newArr.push(el)
                            }
                        } else {
                            newArr.push(el)
                        }
                    }
                    that.keyDifficultPoints = newArr

                }
            })
            that.lastContent = currrentContent
        },
        //保存笔记
        saveNote(deleteIds) {
            const { courseTypeName, courseTypeCode } = getCourseTypeInfo()
            let keyDifficultPoints = [...this.keyDifficultPoints]
            let note = this.editor.getContent()
            if (!note) {
                if (!this.noteInfo.id) {
                    return
                } else {
                    //清空内容，删除笔记
                    API.reqCourseNoteDel([this.noteInfo.id]).then(res => {
                        //西工大统计-删除笔记
                        const obj = {
                            eventCode: this.noteInfo.id ? 'update_note' : 'create_note',
                            eventOpeartionObjectCatelogName: courseTypeName,
                            eventOpeartionObjectCatelogCode: courseTypeCode,
                            eventOpeartionObjectName: this.note_info.courseName,
                            eventOpeartionObjectCode: this.noteInfo.courseId,
                            eventOpeartionObjectDetail: note,
                            eventOpeartionResult: res.statusCode == 200 ? '成功' : '失败'
                        }
                        npuEventStatistics(obj)
                    })
                    this.noteInfo = {}
                    return
                }
            }
            let param = {
                ...this.note_info,
                keyDifficultPoints: note ? keyDifficultPoints : [],
                note,
                type: 'richText',
                id: this.noteInfo.id,
            }
            //内容有更新才保存
            if (this.previewNote && this.previewNote == JSON.stringify(param)) return
            this.previewNote = JSON.stringify(param)
            console.log(param)
            API.reqUpsertNote(param).then(res => {
                //西工大统计-添加、编辑笔记
                const obj = {
                    eventCode: this.noteInfo.id ? 'update_note' : 'create_note',
                    eventOpeartionObjectCatelogName: courseTypeName,
                    eventOpeartionObjectCatelogCode: courseTypeCode,
                    eventOpeartionObjectName: this.note_info.courseName,
                    eventOpeartionObjectCode: this.noteInfo.courseId,
                    eventOpeartionObjectDetail: note,
                    eventOpeartionResult: res.statusCode == 200 ? '成功' : '失败'
                }
                npuEventStatistics(obj)
                if (res.statusCode == 200) {
                    if (deleteIds && deleteIds.length) {
                        //更新完成删除老数据
                        API.reqCourseNoteDel(deleteIds)
                    }
                    if (!this.noteInfo.id) {
                        this.noteInfo.id = res.data
                    }
                    //更新完后删除，防止笔记删除了重难点还在
                    if (!note) {
                        API.reqCourseNoteDel([this.noteInfo.id])
                        this.noteInfo = {}
                    }
                }
            })
        },
        //判断图片是否全黑
        isBase64ImageAllBlack(base64Image) {
            return new Promise((res, rej) => {
                if (!base64Image) res(true)
                // 将Base64解码为图像
                var img = new Image();
                img.src = base64Image;
                // 等待图像加载完成后进行处理
                img.onload = function () {
                    var canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;
                    var context = canvas.getContext('2d');
                    context.drawImage(img, 0, 0, img.width, img.height);
                    // 获取图像的像素数据
                    var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                    // 检查每个像素是否为黑色
                    let flag = true
                    for (var i = 0; i < imageData.data.length; i += 4) {
                        if (imageData.data[i] !== 0 || imageData.data[i + 1] !== 0 || imageData.data[i + 2] !== 0) {
                            // 如果存在非黑色的像素，则返回false
                            flag = false
                        }
                    }
                    res(flag)
                };
            })
        },
        imageToBase64(url) {
            return new Promise((resolve) => {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url);
                xhr.responseType = "blob";
                xhr.onload = function () {
                    var reader = new FileReader();
                    reader.onloadend = function () {
                        var base64data = reader.result;
                        resolve(base64data);
                    };
                    reader.readAsDataURL(xhr.response);
                };
                xhr.send();
            })
        },
        getBase64Image(img) {
            var canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, img.width, img.height);
            var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
            var dataURL = canvas.toDataURL("image/" + ext);
            return dataURL;
        },
        getCanvasBase64(src) {
            const that = this
            return new Promise((resolve) => {
                var image = new Image();
                image.crossOrigin = '';
                image.src = src;
                image.onload = function () {
                    var base64 = that.getBase64Image(image);
                    resolve(base64);
                }
            })
        },
        //视频截图
        async videoScreenShot() {
            const that = this
            return new Promise((resolve) => {
                function getMobileScreenShoot() {
                    return new Promise((resolve1) => {
                        let noteId = Date.now().toString()
                        let ns100 = parseInt(that.player.currentTime * 10000000)
                        let interval
                        let contentId = that.note_info.contentId || that.player.videoIds[0] || ''
                        API.reqNoteScreenshot({ contentId, ns100, noteId }).then(res => {
                            if (res.statusCode == 200) {
                                let times = 0
                                //轮询查询抽帧结果
                                interval = setInterval(() => {
                                    API.reqNoteScreenshotStatus({ contentId, ns100, noteId }).then(async (res) => {
                                        console.log('reqNoteScreenshotStatus', res)
                                        if (!res.statusCode || !res.data || !res.data.length) return
                                        clearInterval(interval)
                                        let imageBase64 = await that.getCanvasBase64(res.data[res.data.length - 1].filePath)
                                        resolve1(imageBase64)
                                    }).catch(() => {
                                        clearInterval(interval)
                                        that.screenShotLoading = false
                                        resolve1('')
                                    })
                                    if (times >= 30) {
                                        //轮询最多30s
                                        clearInterval(interval)
                                        resolve1('')
                                    }
                                    times += 1
                                }, 1000)
                            } else {
                                clearInterval(interval)
                                resolve1('')
                            }
                        }).catch(() => {
                            clearInterval(interval)
                            resolve1('')
                        })
                    })
                }
                function shot() {
                    return new Promise(async (resolve, reject) => {
                        if (!that.getIfPc() && !that.isLive) {
                            // API.reqNoteScreenshot({ contentId: that.note_info.contentId, ns100: parseInt(that.player.currentTime * 10000000), noteId: res.data }).then
                            const base64 = await getMobileScreenShoot()
                            //移动端后端抽帧
                            return resolve(base64)
                        }
                        try {
                            let quality = 0.6
                            if (that.player.screenshoot) {
                                //多分屏截图
                                let cvs = that.player.screenshoot()
                                resolve(cvs.toDataURL("image/jpeg", quality))
                            } else {
                                var canvas = document.createElement("canvas");
                                canvas.width = 1080;
                                let scale = canvas.width / that.player.video.videoWidth
                                canvas.height = that.player.video.videoHeight * scale;
                                let canvasCtx = canvas.getContext("2d");
                                canvasCtx.drawImage(
                                    that.player.video,
                                    0,
                                    0,
                                    canvas.width,
                                    canvas.height
                                );
                                resolve(canvas.toDataURL("image/jpeg", quality));
                            }
                        } catch (err) {
                            console.error(err)
                            resolve(null)
                        }
                    });
                }
                shot().then(async (src) => {
                    //直播移动端无法抽取关键帧或者关键帧为黑屏的时候使用封面作为关键帧图片
                    let isAllBlank = await that.isBase64ImageAllBlack(src)
                    let defaultImage = that.note_info.defaultImage
                    // if (defaultImage) {
                    //     defaultImage = await that.imageToBase64(defaultImage)
                    // }
                    if (isAllBlank && defaultImage) {
                        src = defaultImage
                    }
                    if (src) {
                        API.reqUploadNoteImg({ courseId: that.note_info.courseId, imgs: [src] }).then(res => {
                            console.log(res)
                            if (res.statusCode == 200) {
                                resolve(res.data[0])
                            } else {
                                resolve('')
                            }
                        }).catch(err => {
                            resolve('')
                        })
                    } else {
                        resolve('')
                    }
                })
            })

        },
        playerSeek(item) {
            const { pointIn, note } = item
            let currentTime = pointIn / 10000000;
            this.$emit('seek', { currentTime, videoId: note })
        },
        addNoteHandel() {
            this.addScreenshootNoteHandel()
        },
        //添加截图笔记
        addScreenshootNoteHandel() {
            const that = this
            if (!that.has_login) return that.$message.info("请先登录！")
            if (!this.player || (!this.player.src && !this.player.urls)) {
                return this.$message.info("未检测到视频");
            }
            this.screenshootLoading = true
            this.videoScreenShot().then(async (screenshootSrc) => {
                let pointIn = parseInt(this.isLive ? 0 : this.player.currentTime * 10000000) || 0
                that.insertNote({ type: 'screenshoot', img: screenshootSrc, time: pointIn })
            }).finally(() => {
                this.screenshootLoading = false
            })
        },
        //添加时间点笔记
        addTimeNoteHandel() {
            const that = this
            if (!that.has_login) return that.$message.info("请先登录！")
            if (!this.player || (!this.player.src && !this.player.urls)) {
                return this.$message.info("未检测到视频");
            }
            let time = parseInt(this.isLive ? 0 : this.player.currentTime * 10000000) || 0
            let timeFormat = durationTrans(time)
            this.timeNoteParams = {
                timeFormat,
                time,
                tag: [],
                text: ''
            }
            this.timeNoteVisible = true
            if (this.player && !this.player.paused) {
                this.timeNoteParams.ifPaused = true
                this.player.pause()
            }
        },
        addTimeNoteConfirm() {
            if (this.timeNoteParams.tag.length) {
                this.keyDifficultPoints.push({
                    isKeyPoint: this.timeNoteParams.tag.includes('1'),
                    isDifficultPoint: this.timeNoteParams.tag.includes('2'),
                    pointIn: this.timeNoteParams.time,
                    pointOut: this.timeNoteParams.time,
                    timePointName: this.timeNoteParams.text
                })
            }
            this.insertNote({ type: 'time', time: this.timeNoteParams.time, timeFormat: this.timeNoteParams.timeFormat, text: this.timeNoteParams.text, tag: this.timeNoteParams.tag })
            this.timeNoteVisible = false
        },
        //插入笔记
        insertNote(option) {
            this.editor.insertContent(getNoteHtml(option) + '<br/>')
        },
        //下载笔记
        handleDownloadNote() {
            let note = this.editor.getContent()
            if (!note) return this.$message.info('暂无笔记')
            let data = [{
                isLearn: true,
                courseName: this.note_info.courseName,
                sectionName: this.note_info.sectionName,
                resourceName: this.note_info.resourceName,
                noteContent: note,
                keyframe: this.noteInfo.keyframe,
                noteType: 'richText'
            }]
            downloadNote(data, {
                courseName: this.note_info.courseName,
                resourceName: this.note_info.resourceName,
            })
            //西工大统计-课程资源下载
            const { courseTypeName, courseTypeCode } = getCourseTypeInfo()
            npuEventStatistics({
                eventCode: 'download_courseResources',
                eventOpeartionObjectCatelogName: courseTypeName,
                eventOpeartionObjectCatelogCode: courseTypeCode,
                eventOpeartionObjectName: this.note_info.courseName,
                eventOpeartionObjectCode: this.noteInfo.courseId,
                eventOpeartionObjectDetail: '下载笔记',
            })
        },
        appendToolbar(editor) {
            const that = this
            let screenshootBtn = jQuery('<div class="screenshoot_btn">').html(`
            <button type="button">
                <span>
                    <svg width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class="iconfont">
                        <use xlink:href="#iconcamera-full"></use>
                    </svg>
                    截图
                </span>
            </button>`)
            let timepointBtn = jQuery('<div class="timepoint_btn">').html(`
            <button type="button">
                <span>
                    <svg width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class="iconfont">
                        <use xlink:href="#iconqizhi-"></use>
                    </svg>
                    时间点
                </span>
            </button> `)
            let downloadBtn = jQuery('<div class="download_btn">').html(`
            <button type="button">
                <span>
                    <svg width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class="iconfont">
                        <use xlink:href="#iconxiazai3"></use>
                    </svg>
                    下载笔记
                </span>
            </button> `)
            screenshootBtn.on('click', function () {
                //点击截图
                that.addScreenshootNoteHandel()
            })
            timepointBtn.on('click', function () {
                //点击时间点
                that.addTimeNoteHandel()
            })
            downloadBtn.on('click', function () {
                //点击下载笔记
                that.handleDownloadNote()
            })
            let toolBarDom = document.createElement('div')
            toolBarDom.className = 'custom_tool_bar'
            if (that.file_type == 'biz_sobey_video') {
                jQuery(toolBarDom).append(screenshootBtn)
            }
            if (that.file_type == 'biz_sobey_video' || that.file_type == 'biz_sobey_audio') {
                jQuery(toolBarDom).append(timepointBtn)
            }
            jQuery(toolBarDom).append(downloadBtn)
            jQuery(editor.editorContainer).find('.tox-editor-header').after(toolBarDom)
        }
    },
    template: `
  <div :class="{course_note_panel_new: true, not_video:!ifVideo}" v-loading="screenshootLoading">
      <div ref="textarea"></div>
      <el-dialog :visible.sync="timeNoteVisible" custom-class="time_note_modal" @closed="timeNoteParams.ifPaused && player && player.paused && player.play()">
        <div class="time_wrap"><iconfont type="iconqizhi-"></iconfont><span>{{timeNoteParams.timeFormat}}</span></div>
        <el-input v-model="timeNoteParams.text" :placeholder="$t('输入时间点名称（选填）')" :maxlength="11" show-word-limit></el-input>
        <div>
            <el-checkbox-group v-model="timeNoteParams.tag">
                <el-checkbox label="1"><iconfont type="iconlujing"></iconfont>{{$t('重点')}}</el-checkbox>
                <el-checkbox label="2"><iconfont type="iconlujing"></iconfont>{{$t('难点')}}</el-checkbox>
            </el-checkbox-group>
        </div>
        <div slot="footer">
            <el-button type="primary" @click="addTimeNoteConfirm">{{$t('确定')}}</el-button>
            <el-button @click="timeNoteVisible = false">{{$t('取消')}}</el-button>
        </div>
      </el-dialog>
  </div>
  `,
});